import { render, staticRenderFns } from "./CriarContaDigital.vue?vue&type=template&id=ec653a2a"
import script from "./CriarContaDigital.vue?vue&type=script&lang=js"
export * from "./CriarContaDigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports